import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import axios from "axios";
import SidePanel from "../Components/SidePanel";
import { FiEye, FiPlus } from "react-icons/fi";
import { Switch } from "@mui/material";
import { toast } from "react-toastify";
import AddCustomer from "../Components/AddCustomers";

const Customer = () => {
  const [isCollapsed, setCollapsed] = useState(false);
  const [isAddCustomerModalOpen, setAddCustomerModalOpen] = useState(false);

  // Toggle SidePanel collapse state
  const toggleSidePanel = () => {
    setCollapsed((prev) => !prev);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const fetchCustomers = async () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/superadmin/get_customers/`)
      .then((response) => {
        const formattedUsers = response.data.map((user, index) => ({
          ...user,
          sno: index + 1,
        }));

        console.log("users", users);
        console.log("formattedUsers", formattedUsers);

        setUsers(formattedUsers);
      })
      .catch((error) => {
        console.error("Error fetching cameras:", error);
      });
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const columns = [
    {
      field: "sno",
      headerName: "S.No.",
      flex: 1.5,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "farm_name",
      headerName: "Farm name",
      flex: 2,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "email",
      headerName: "Email ID",
      flex: 2,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "is_active",
      headerName: "Status",
      flex: 2,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        // Add console logs to see what's happening
        const handleToggle = async () => {
          try {
            const updatedStatus = !params.row.is_active;
            console.log("Attempting to update status to:", updatedStatus);

            const response = await axios.post(
              `${process.env.REACT_APP_BASE_URL}/superadmin/update_customer_status/${params.row.id}/`,
              { is_active: updatedStatus }
            );

            console.log("Response:", response);

            toast.success("Status Updated Successfully!");
            fetchCustomers();
          } catch (error) {
            console.error("Error object:", error);
            if (error.response) {
              console.error("Response status:", error.response.status);
              console.error("Response data:", error.response.data);
            }
            toast.error("Something went wrong!");
          }
        };

        return (
          <Switch
            checked={params.row.is_active}
            onChange={handleToggle}
            color="success"
          />
        );
      },
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <Link
            to={`/view-customer/${params.row.id}`}
            state={{ user: params.row }}
          >
            <FiEye size={20} style={{ cursor: "pointer" }} title="View" />
          </Link>
        </div>
      ),
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  return (
    <div>
      <Header toggleSidePanel={toggleSidePanel} />

      <div className="flex">
        <SidePanel isCollapsed={isCollapsed} />
        <main className="bg-[#282828] w-full overflow-hidden">
          <section className="flex justify-between py-10">
            <div className="pl-4">
              <h3 className="title-header">Customer Management</h3>
            </div>
            <div className="pr-4">
              <button
                onClick={() => setAddCustomerModalOpen(true)}
                className="bg-green-600 hover:bg-green-700 px-6 py-2 rounded-md text-white font-semibold transition flex items-center gap-1"
              >
                <FiPlus size={20} style={{ cursor: "pointer" }} />
                <span>Add Customer</span>
              </button>
            </div>
          </section>
          <section className="px-4 cam-table mb-10">
            <div
              style={{ width: "100%" }}
              className="bg-[#282828] h-full rounded-md shadow-[0_8px_20px_#000000] tables-h"
            >
              <DataGrid
                rows={users}
                columns={columns}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[10, 25, 50, 100]}
                disableSelectionOnClick
                className="bg-[#282828] text-[#cccfcd]"
                disableColumnMenu
                disableColumnReorder
                disableColumnResize
                localeText={{ noRowsLabel: "No Customers Found" }}
                sx={{
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 600,
                  },
                  "& .MuiDataGrid-columnHeaderTitleContainer": {
                    fontSize: "16px",
                    fontWeight: 600,
                    justifyContent: "center",
                    textAlign: "center",
                  },
                  "& .MuiDataGrid-cell": {
                    color: "#e6e6e6",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                  "& .MuiDataGrid-overlay": {
                    fontSize: "16px",
                    color: "#ffffff",
                    backgroundColor: "transparent",
                  },
                  "& .MuiDataGrid-row": {
                    borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
                  },
                  "& .MuiDataGrid-cell:focus": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-row:focus": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-row.Mui-selected": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeader:focus": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeader:focus-within": {
                    outline: "none",
                  },
                  "& .MuiTablePagination-root": {
                    color: "#ffffff",
                  },
                  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                    {
                      color: "#ffffff",
                    },
                  "& .MuiTablePagination-actions button": {
                    color: "#ffffff",
                  },
                }}
              />
            </div>
          </section>
        </main>
      </div>

      <AddCustomer
        isOpen={isAddCustomerModalOpen}
        onClose={() => setAddCustomerModalOpen(false)}
        onCustomerAdded={fetchCustomers}
      />
    </div>
  );
};
export default Customer;
